import React, { useState } from "react";
import { GoPlus } from "react-icons/go";
import { Collapse, CardBody, Card } from "reactstrap";

const FAQ = (args) => {
  const [openItem, setOpenItem] = useState(null);

  const toggle = (item) => {
    setOpenItem(openItem === item ? null : item);
  };

  return (
    <>
      <div className="faq-container">
        <div className="faq-header">
          <h2>YOUR QUESTIONS, ANSWERED</h2>
          <h3>Dive into Our FAQs</h3>
        </div>

        <div
          className="faq-item"
          onClick={() => toggle(1)}
        >
          <span className="faq-font">
            Who is this bootcamp for?
          </span>

          <span className="faq-icon">
            <GoPlus />
          </span>
        </div>

        <Collapse isOpen={openItem === 1} {...args}>
          <Card className="faq-collapse">
            <CardBody>
              This bootcamp is designed for beginners who want to start coding, 
              freshers preparing for placements, and early-career professionals 
              looking to strengthen their Data Structures and Algorithms skills.
            </CardBody>
          </Card>
        </Collapse>

        <div
          className="faq-item"
          onClick={() => toggle(2)}
        >
          <span className="faq-font">
            What will I learn in 30 days?
          </span>

          <span className="faq-icon">
            <GoPlus />
          </span>
        </div>

        <Collapse isOpen={openItem === 2} {...args}>
          <Card className="faq-collapse">
            <CardBody>
              You will cover arrays, strings, linked lists, stacks, queues, 
              trees, graphs, recursion, dynamic programming, and more. Each day 
              introduces a new concept with a hands-on coding challenge.
            </CardBody>
          </Card>
        </Collapse>

        <div
          className="faq-item"
          onClick={() => toggle(3)}
        >
          <span className="faq-font">
            Do I need prior coding experience?
          </span>

          <span className="faq-icon">
            <GoPlus />
          </span>
        </div>

        <Collapse isOpen={openItem === 3} {...args}>
          <Card className="faq-collapse">
            <CardBody>
              Basic familiarity with any programming language helps, but the 
              first week starts from fundamentals. We provide starter code and 
              hints for every challenge to guide you through.
            </CardBody>
          </Card>
        </Collapse>

        <div
          className="faq-item"
          onClick={() => toggle(4)}
        >
          <span className="faq-font">
            Is there a certificate at the end?
          </span>

          <span className="faq-icon">
            <GoPlus />
          </span>
        </div>

        <Collapse isOpen={openItem === 4} {...args}>
          <Card className="faq-collapse">
            <CardBody>
              Yes, all participants who complete the 30-day program receive a 
              certificate of participation from DataCode. It is a great addition 
              to your resume and LinkedIn profile.
            </CardBody>
          </Card>
        </Collapse>

        <div
          className="faq-item"
          onClick={() => toggle(5)}
        >
          <span className="faq-font">
            How much does it cost and what is included?
          </span>

          <span className="faq-icon">
            <GoPlus />
          </span>
        </div>

        <Collapse isOpen={openItem === 5} {...args}>
          <Card className="faq-collapse">
            <CardBody>
              The bootcamp is available at just ₹149 and includes 30 coding challenges, 
              mentor feedback, lifetime access to all materials, and community support. 
              We also offer 100% scholarships for up to 100 students.
            </CardBody>
          </Card>
        </Collapse>
      </div>
    </>
  );
};

export default FAQ;
